//
//  src/layouts/default/contact/Form.js
//
import * as React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import Nav      from "../../../../components/nav/Nav"
import Enquire  from "../../../../components/enquire/Enquire"
import Footer   from "../../../../components/footer/Footer"
import './Form.css'


//
//  form
//
export default function Form() {
    const location = useLocation();
    const canonicalUrl = `https://jefftattooer.com${location.pathname}`.replace(/\/$/, '') || 'https://jefftattooer.com/contact/form';
    const ogImage = 'https://jefftattooer.com/logo512.png';
    const pageTitle = 'Contact Jeff Tattooer | Send a Message';
    const pageDescription = 'Contact Jeff Tattooer with your tattoo questions or design ideas. Send us a message and we\'ll get back to you. Free consultations available.';
    
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": pageTitle,
        "description": pageDescription,
        "url": canonicalUrl,
        "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://jefftattooer.com"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Contact",
                    "item": "https://jefftattooer.com/contact"
                },
                {
                    "@type": "ListItem",
                    "position": 3,
                    "name": "Contact Form",
                    "item": canonicalUrl
                }
            ]
        }
    };
    
    return (
        <div className="form">
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={pageDescription} />
                <link rel="canonical" href={canonicalUrl} />
                
                {/* Open Graph */}
                <meta property="og:title" content={pageTitle} />
                <meta property="og:description" content={pageDescription} />
                <meta property="og:image" content={ogImage} />
                <meta property="og:url" content={canonicalUrl} />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Jeff Tattooer" />
                
                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={pageTitle} />
                <meta name="twitter:description" content={pageDescription} />
                <meta name="twitter:image" content={ogImage} />
            </Helmet>
            <Helmet>
                <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
            </Helmet>
            <Nav     />
            <Enquire />
            <Footer  />
        </div>
    );
}
